import { defineMeta } from '@/registry/types';

export const toggleButtonMeta = defineMeta({
  name: 'ToggleButton',
  level: 'atom',
  category: 'input',
  classification: 'themed-mui',
  description: 'Selectable button for segmented / exclusive controls. Themed MUI ToggleButton(Group).',
  baseLibrary: '@mui/material',
  muiEquivalent: 'ToggleButton',
  muiDocs: 'https://mui.com/material-ui/react-toggle-button/',
  a2uiEquivalent: 'SegmentedControl',
  importPath: '@/atoms/ToggleButton',
  optionalProps: ['value', 'selected', 'disabled', 'size', 'exclusive (group)'],
  supportedStates: ['default', 'selected', 'disabled', 'focus'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Group with ToggleButtonGroup and provide aria-label; icon-only buttons need aria-label.'],
  usageExamples: ['<ToggleButtonGroup exclusive><ToggleButton value="a">A</ToggleButton></ToggleButtonGroup>'],
  antiPatterns: ['Do not use a single ToggleButton where a Switch is clearer.'],
  llmSafe: true,
  whenToUse: ['View switches, formatting toolbars, exclusive options'],
  whenNotToUse: ['Submitting actions (use Button)'],
});

export default toggleButtonMeta;
